module.exports = __webpack_public_path__ + "img/balkonbruestung_2.6c7a4751.webp";